<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listNationalities"
        :title-table="$t('Nationality')"
        module="nationalitySettingsModule"
        sort-name="nome"
        add-permission="ROLE_NACIONALIDADE_INSERIR"
        view-permission="ROLE_NACIONALIDADE_CONSULTAR"
        edit-permission="ROLE_NACIONALIDADE_ATUALIZAR"
        delete-permission="ROLE_NACIONALIDADE_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormNacionality
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormNacionality from './forms/FormNacionality.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormNacionality,
  },
  computed: {
    ...mapState('nationalitySettingsModule', {
      listNationalities: state => state.listNationalities,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Descrição',
          field: 'nome',
        },
        {
          label: 'Sigla',
          field: 'sigla',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'nationalitySettingsModule/prepareToEditNacionality',
        data,
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
